import { List } from 'antd';
import React from 'react';

import CopyableText from '@fmbt/ui/CopyableText';
import Field from '@fmbt/ui/Field';
import { EM_DASH } from 'constants/index';

// ==============================
// TYPES
// ==============================
export interface ContentItem {
  content: string | JSX.Element;
  /** Is the Serial Number searchable on Devices page */
  isSearchableSerialNumber?: boolean;
  label: string | JSX.Element;
};

type SensorAboutTabProps = {
  contentItems: ContentItem[];
  /** Provide this prop if you need to customise the display of searchable Serial Number */
  renderSearchableSerialNumber?: (item: ContentItem) => JSX.Element;
};

// ==============================
// COMPONENTS
// ==============================
function SensorAboutTab({
  contentItems,
  renderSearchableSerialNumber
}: SensorAboutTabProps) {

  const handleRenderItem = (item: ContentItem) => {
    const {
      label,
      content,
      isSearchableSerialNumber
    } = item;

    // Special treatment as requested by the caller
    if (isSearchableSerialNumber && renderSearchableSerialNumber) {
      return renderSearchableSerialNumber(item);
    }

    const isSerialNumber = /Serial Number/.test(label as string);

    return (
      <List.Item>
        <Field label={label}>
          {typeof content === 'string' ? (
            content !== EM_DASH && isSerialNumber ? (
              <CopyableText>{content}</CopyableText>
            ) : (
              <div className="body-copy">{content}</div>
            )
          ) : (
            content
          )}
        </Field>
      </List.Item>
    );
  };

  return (
    <List
      dataSource={contentItems}
      renderItem={handleRenderItem}
    />
  );
}

export default SensorAboutTab;